/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalStaffNotification_requestSaveNotifications } from '../models/api_portalStaffNotification_requestSaveNotifications';
import type { api_portalStaffNotification_responseSaveNotifications } from '../models/api_portalStaffNotification_responseSaveNotifications';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalStaffNotificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Save multiple notifications
     * Saves multiple portal staff notifications at once
     * @returns api_portalStaffNotification_responseSaveNotifications responseSaveNotifications
     * @throws ApiError
     */
    public postPortalStaffNotificationsSave({
        body,
    }: {
        /**
         * requestSaveNotifications
         */
        body: api_portalStaffNotification_requestSaveNotifications,
    }): CancelablePromise<api_portalStaffNotification_responseSaveNotifications> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff_notifications/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
